var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.Message)}}),(_vm.Link)?_c('a',{attrs:{"href":_vm.Link}},[_c('v-btn',{attrs:{"x-small":"","text":"","color":"secondary"}},[_vm._v("View")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }